import { type Client, createClient } from '@connectrpc/connect';
import { WarehouseAPIService } from '@project-gd-x/dating-site-contracts/src/gen/gdx/warehouse/v1/warehouse_api_connect';
import {
  GetRequest,
  GetResponse,
  SaveRequest,
  SaveRequest_Value,
  SaveResponse,
} from '@project-gd-x/dating-site-contracts/src/gen/gdx/warehouse/v1/warehouse_api_pb';
import {
  WarehouseRecord,
  WarehouseKey,
} from '@project-gd-x/shared-web/src/helpers/warehouse-keys/types/types';

import { getUserId } from '@/helpers/auth/auth';
import { getGrpcWebTransport } from '@/services/api/grpc-api';

const MONTH_SECONDS = 60n * 60n * 24n * 30n;
let client: Client<typeof WarehouseAPIService>;

function getClient() {
  if (!client) {
    client = createClient(WarehouseAPIService, getGrpcWebTransport());
  }

  return client;
}

/**
 * Get values for specific keys from warehouse for a user
 */
async function get(keyList: WarehouseKey[]): Promise<GetResponse> {
  const request = new GetRequest({
    userId: getUserId(),
    keys: keyList,
  });

  return getClient().get(request);
}

/**
 * Save key-value pairs in warehouse for a user
 */
async function save(itemList: WarehouseRecord): Promise<SaveResponse> {
  const itemsMap: { [key: string]: SaveRequest_Value } = {};

  Object.entries(itemList).forEach(([key, itemValue]) => {
    itemsMap[key] = new SaveRequest_Value({
      value: itemValue.value,
      expirationDuration: {
        seconds: itemValue.expirationDurationSeconds ?? MONTH_SECONDS,
        nanos: 0,
      },
    });
  });

  const request = new SaveRequest({
    userId: getUserId(),
    items: itemsMap,
  });

  return getClient().save(request);
}

export const warehouseApi = {
  get,
  save,
};
